export default {
    parts: ['container', 'grid', 'leftColumn', 'rightColumn'],
    baseStyle: () => ({
        container: {
            width: '100%',
            overflow: 'hidden',
            '& [data-image-only="true"]': {
                '& div': {
                    height: '100%'
                },
                '& picture': {
                    display: 'block !important',
                    height: '100% !important'
                },
                '& img': {
                    height: '100% !important',
                    objectFit: 'cover',
                    objectPosition: 'center'
                }
            }
        },
        grid: {
            width: '100%'
        },
        leftColumn: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        },
        rightColumn: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        }
    })
}
